<template>
    <div>
        <!--CurrentDate: {{currentDate}}
    Min: {{dateMinVal}}
    Max: {{dateMaxVal}}-->
        <kendo-datetimepicker v-if="showTime"
                              :ref="'datepicker' + uid"
                              :value="currentDate"
                              @change="inputChanged"
                              @open="onOpen"
                              :format="customFormat"
                              :name="'datetimepicker' + uid"
                              :style="`width: 100%; font-size:${fontSize};`"
                              :start="datepickerStart"
                              :depth="datepickerDepth"
                              :disabled="readonly"
                              :min="dateMinVal"
                              :max="dateMaxVal"
                              :interval="5"
                              :timeFormat="'HH:mm'"></kendo-datetimepicker>

        <kendo-datepicker v-else
                          :ref="'datepicker' + uid"
                          :value="currentDate"
                          @change="inputChanged"
                          @open="onOpen"
                          :format="customFormat"
                          :name="'datetimepicker' + uid"
                          :style="`width: 100%; font-size:${fontSize};`"
                          :start="datepickerStart"
                          :depth="datepickerDepth"
                          :disabled="readonly"
                          :min="dateMinVal"
                          :max="dateMaxVal"
                          :interval="5"
                          :timeFormat="'HH:mm'"></kendo-datepicker>
        <span class="text-danger col-12" v-if="error">{{ error }}</span>
    </div>
</template>

<script>
    export default {
        $_veeValidate: {
            name() {
                return this.fieldName;
            },
            value() {
                return this.date;
            }
        },
        props: {
            value: [Date, String],
            required: {
                type: Boolean,
                default: false
            },
            format: {
                type: String
            },
            showTime: {
                type: [Boolean, String],
                default: true
            },
            readonly: {
                type: Boolean,
                default: false
            },
            min: {
                type: [Date, String],
                required: false
            },
            max: {
                type: [Date, String],
                required: false
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
            fieldName: String,
            error: {
                type: String,
                required: false
            },
            convertDateToUtc: {
                type: Boolean,
                default: true
            },
            bindPopup: {
                type: Boolean,
                default: false
            },
            popupContainerId: {
                type: String,
                default: ''
            },
            fontSize: {
                type: String,
                default: '1rem'
            }
        },
        data() {
            return {
                uid: Math.floor(Math.random() * 0x10000).toString(16),
                currentDate: null,
                date: null,
                changedFromPicker: false,
                defaultDateMinVal: new Date(1900, 0, 1),
                defaultDateMaxVal: new Date(2159, 0, 1),
                customFormat: ''
            };
        },
        methods: {
            getWidget() {
                const refName = `datepicker${this.uid}`;
                const ref = this.$refs[refName];
                if (!ref || typeof ref.kendoWidget !== 'function') {
                    return null;
                }

                return ref.kendoWidget();
            },
            applyPopupContainer(widget) {
                if (!this.bindPopup || !this.popupContainerId) {
                    return;
                }

                const $ = window.kendo && window.kendo.jQuery ? window.kendo.jQuery : null;
                if (!$ || !widget) {
                    return;
                }

                const container = $(this.popupContainerId);
                if (!container || !container.length) {
                    return;
                }

                const bindPopup = (popup) => {
                    if (!popup) return;

                    if (typeof popup.setOptions === 'function') {
                        popup.setOptions({ appendTo: container });
                    } else if (popup.options) {
                        popup.options.appendTo = container;
                    }

                    if (popup.element && typeof popup.element.appendTo === 'function') {
                        popup.element.appendTo(container);
                    }

                    if (typeof popup.position === 'function') {
                        popup.position();
                    }
                };

                // DateTimePicker има два popup-а (календар + time list), DatePicker има само календар.
                bindPopup(widget.dateView && widget.dateView.popup);
                bindPopup(widget.timeView && widget.timeView.popup);
            },
            onOpen(e) {
                // При отваряне гарантираме, че popup-ът се рендерира в контейнера на модала.
                const widget = e && e.sender ? e.sender : this.getWidget();
                this.applyPopupContainer(widget);
            },
            inputChanged(event) {
                console.log('change: ', event.sender.value());

                if (this.showTime) {
                    this.date = event.sender.value();
                } else {
                    if (this.convertDateToUtc) {
                        // date picker need to be in UTC
                        const d = new Date(event.sender.value());
                        const utc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
                        this.date = new Date(utc);
                    } else {
                        this.date = event.sender.value();
                    }
                }

                this.$emit('input', this.date);
                this.$emit('change', this.date);
            }
        },
        watch: {
            value: function (newVal) {
                if (newVal !== this.date) { // 01.06.2021 Only Datepicker max issus
                    this.currentDate = this.date = newVal;
                }
            }
        },
        computed: {
            popup() {
                const $ = window.kendo && window.kendo.jQuery ? window.kendo.jQuery : null;
                if (!this.bindPopup || !this.popupContainerId || !$) {
                    return undefined;
                }

                return {
                    appendTo: $(this.popupContainerId)
                };
            },
            // Трябва да се направи така понеже ако подадем new Date() слага сегашния час
            // и прави интервалите от по 5 минути от него нататък
            dateMinVal() {
                var d = this.min || this.defaultDateMinVal;
                if (d instanceof Date === false) {
                    d = new Date(d);
                }

                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            dateMaxVal() {
                var d = this.max || this.defaultDateMaxVal;
                if (d instanceof Date === false) {
                    d = new Date(d);
                }

                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            datepickerStart() {
                return this.showOnlyYear ? 'decade' : 'month'; // mounth is default value
            },
            datepickerDepth() {
                return this.showOnlyYear ? 'decade' : '';
            }
        },
        mounted() {
            kendo.culture('bg-BG');

            if (!this.format) {
                if (this.showOnlyYear) {
                    this.customFormat = 'yyyy';
                } else {
                    if (!this.showTime) {
                        this.customFormat = 'dd.MM.yyyy';
                    } else {
                        this.customFormat = 'dd.MM.yyyy HH:mm';
                    }
                }
            } else {
                this.customFormat = this.format;
            }

            if (this.value) {
                this.currentDate = this.date = this.value;
            }

            // Първоначално биндваме popup-а към контейнера (в модали често е критично).
            this.$nextTick(() => {
                this.applyPopupContainer(this.getWidget());
            });
        }
    };
</script>
